export const getExternalUrl = (mediaType, externalId, source = null) => {
    if (!externalId) return '#';

    if (mediaType.toLowerCase() === 'manga') {
      if (source === 'mangadex') {
        return `https://mangadex.org/title/${externalId}`;
      }
      return `https://myanimelist.net/manga/${externalId}`;
    }

    switch (mediaType.toLowerCase()) {
      case 'anime':
      case 'animemovie':
      case 'animeserie':
      case 'manga':
        return `https://myanimelist.net/${mediaType.toLowerCase()}/${externalId}`;
      case 'steamgame':
        return `https://store.steampowered.com/app/${externalId}`;
      case 'music':
      case 'vinyl':
      case 'cd':
        return `https://www.discogs.com/release/${externalId}`;
      case 'physicalgame':
      case 'pspgame':
      case 'ndsgame':
      case 'gameboygame':
      case 'switchgame':
      case 'ps3game':
      case 'vitagame':
        return `https://www.igdb.com/search?type=1&q=${externalId}`;
      case 'tv':
        return `https://www.themoviedb.org/tv/${externalId}`;
      case 'movie':
      case 'screenmedia':
        return `https://www.themoviedb.org/movie/${externalId}`;;
      default:
        return '#';
    }
  };